var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{on:{"click":_vm.toggleSidebar}},[_c('router-link',{staticClass:"menu-item",class:{ active: _vm.isActiveLink },attrs:{"to":_vm.link}},[_c('img',{attrs:{"src":`/icons/${_vm.linkIcon}.svg`,"alt":"Link Icon"}}),(!_vm.isCollapsed)?_c('span',[_vm._v(_vm._s(_vm.linkText))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }